import { Card, CardContent } from "@/components/ui/card";
import { Users, CreditCard, AppWindow, Settings } from "lucide-react";

import type { Account } from "@/redux/api/accounts.rtkq";
import type { Plan } from "@/redux/api/plans.rtkq";
import type { App } from "@/redux/api/apps.rtkq";

interface StatsOverviewProps {
  accounts: Account[] | undefined;
  plans: Plan[] | undefined;
  apps: App[] | undefined;
  accountsLoading: boolean;
  plansLoading: boolean;
  appsLoading: boolean;
}

const StatsOverview = ({ accounts, plans, apps, accountsLoading, plansLoading, appsLoading }: StatsOverviewProps) => {
  // Calculate real stats
  const totalAccounts = accounts?.length || 0;
  const totalPlans = plans?.length || 0;
  const totalApps = apps?.length || 0;
  const totalCredits = accounts?.reduce((sum, account) => sum + (account.creditBalance || 0), 0) || 0;

  const stats = [
    {
      title: "סך כל החשבונות",
      value: totalAccounts.toLocaleString(),
      description: "חשבונות פעילים במערכת",
      icon: Users,
      color: "text-blue-600",
      loading: accountsLoading,
    },
    {
      title: "תוכניות מנוי",
      value: totalPlans.toLocaleString(),
      description: "תוכניות זמינות",
      icon: CreditCard,
      color: "text-green-600",
      loading: plansLoading,
    },
    {
      title: "אפליקציות",
      value: totalApps.toLocaleString(),
      description: "אפליקציות במערכת",
      icon: AppWindow,
      color: "text-purple-600",
      loading: appsLoading,
    },
    {
      title: "קרדיטים כולל",
      value: totalCredits.toLocaleString(),
      description: "קרדיטים זמינים",
      icon: Settings,
      color: "text-orange-600",
      loading: accountsLoading,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
      {stats.map((stat, index) => (
        <Card key={index} className="bg-white shadow-lg">
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-slate-600">{stat.title}</p>
                {stat.loading ? (
                  <div className="h-8 w-16 bg-slate-200 rounded animate-pulse mt-1" />
                ) : (
                  <p className="text-2xl font-bold text-slate-900">{stat.value}</p>
                )}
                <p className="text-xs text-slate-500">{stat.description}</p>
              </div>
              <stat.icon className={`h-8 w-8 ${stat.color}`} />
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default StatsOverview;
